import LoanDolphinAPI from '@loandolphin/api';

export const DOCKER_ENV_SETTINGS = {
  clientId: '64723ea9c42af63f625d0aa976f01c4df0cb5433f9d77d6dac6ae46ce2726c79',
  clientSecret: '8afdd0a1d9128f037f59e36ad6b9874626064dd6e9f2c7d62c6611f52d076c5e',
  env: 'production',
  baseUrl: 'http://localhost:3000',
};

function getApi() {
  if (process.env.NODE_ENV === 'docker' || window.location.host.endsWith('localhost:9002')) {
    return new LoanDolphinAPI(DOCKER_ENV_SETTINGS);
  }

  // variables set in '.env.[mode]' files. More info on https://cli.vuejs.org/guide/mode-and-env.html#modes
  const ENV_SETTINGS = {
    clientId: process.env.VUE_APP_CLIENT_ID,
    clientSecret: process.env.VUE_APP_CLIENT_SECRET,
    env: process.env.VUE_APP_API_ENV,
    baseUrl: process.env.VUE_APP_API_BASE_URL,
    useFaker: process.env.VUE_APP_USE_FAKER === 'true',
  };

  return new LoanDolphinAPI(ENV_SETTINGS);
}

export default getApi();
